import isObjectLike from './is-object-like';
import isType from './is-type';
var isPlainObject = function (value) {
    /**
     * isObjectLike(new Foo) => false
     * isObjectLike([1, 2, 3]) => false
     * isObjectLike({ x: 0, y: 0 }) => true
     * isObjectLike(Object.create(null)) => true
     */
    if (!isObjectLike(value) || !isType(value, 'Object')) {
        return false;
    }
    if (Object.getPrototypeOf(value) === null) {
        return true;
    }
    var proto = value;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(value) === proto;
};
export default isPlainObject;
//# sourceMappingURL=is-plain-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-plain-object.js
// module id = 62
// module chunks = 3